module.exports = __webpack_public_path__ + "static/media/night.9a815ed0.svg";